// eslint-disable-next-line no-unused-vars
import styled, { css } from 'styled-components/macro';

export const BtnList = styled.div`
  width: 100%;
  transform: translateY(50px);
  transition: all ease-in-out 0.2s;
  visibility: hidden;
  opacity: 0;
  list-style: none;
  margin: 0 52px 0 0;
  padding: 10px 0 0;

  li {
    margin: 0 0 10px;

    button {
      width: 100%;
    }
  }
`;

export const BtnWrap = styled.div`
  position: static;
  display: flex;
  align-items: center;
  max-width: 450px;
  width: 100%;
  justify-content: flex-end;

  button {
    margin: 0 0 0 10px;
  }

  @media (max-width: 767px) {
    position: absolute;
    top: 30px;
    right: 20px;
    max-width: 230px;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    z-index: 5;

    button {
      margin: 0;
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
    }
  }

  .btn-menu {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 46px;
    border-radius: 50px;
    background: var(--white);

    i {
      transform: rotate(45deg);
      transition: all ease-in-out 0.2s;
    }
  }

  ${({ active }) =>
    active &&
    css`
      .btn-menu {
        i {
          transform: rotate(0);
        }
      }
      ${BtnList} {
        visibility: visible;
        opacity: 1;
        transform: translateY(0);
      }
    `}
`;
